export default "//cdn.scentbird.com/assets/frontbird-site/images/toner_392163.png";